<template>
    <div class="footer-container">
      <div class="footer" v-bind:class="{ 'footer_left': isActive }">
          Copyright © com <i class="far fa-heart"></i> por Farsoft Systems
        </div>
    </div>
</template>

<script>
// import { Component, Vue } from 'vue-property-decorator'
import fontawesome from '@fortawesome/fontawesome'
// import freeSolid from '@fortawesome/fontawesome-free-solid'
// import brands from '@fortawesome/fontawesome-free-brands'
// import regular from '@fortawesome/fontawesome-free-regular'
import { faHeart } from '@fortawesome/fontawesome-free-regular' // Pega só o coração

// fontawesome.library.add(freeSolid)
// fontawesome.library.add(brands)
// fontawesome.library.add(regular)
fontawesome.library.add(faHeart)

// @Component({
//   components: {
//   Footer
//   },
//   })

export default {
  props: ['isActive'],
  data: () => ({
  })
}

// export default class Footer extends Vue {}
</script>

<style lang="scss">
.footer-container {
    width:100%;
    position:fixed;
    bottom:0px;
    background: #000;
}

.footer {
    height:30px;
    background:#2a2f50;
    border:0px solid #CCC;
    // width:960px;
    margin:0px auto;
    color: #fff;
    line-height: 30px;
    font-size: 0.8em;
    // margin-left: 270px; //Para usar menu fixo
    padding: 0px;
}

.footer_left {
  padding-left: 270px;
}
</style>
